import React from 'react';
import PropTypes from 'prop-types';
import { HomeworkByDate } from './IndividualAssignments/index';

const IndividualAssignments = ({ selectedStudent, currentUser }) => {
  return (
    <div className="max-w-6xl mx-auto px-0 sm:px-2 py-6">
      <HomeworkByDate selectedStudent={selectedStudent} currentUser={currentUser} />
    </div>
  );
};

IndividualAssignments.propTypes = {
  selectedStudent: PropTypes.object,
  currentUser: PropTypes.object.isRequired,
};

export default IndividualAssignments; 